import React from 'react';
import { Box } from '@mui/material';
import { MULTICITY_ROWS_PLACEHOLDER_HEIGHT } from './flightForm.constants';

/** Empty block the size of the multi-city rows, shown while the row chunk loads. */
class MultiCityRowsPlaceholder extends React.Component {
  render() {
    const { count = 0, isMobile = false } = this.props;
    if (count < 1) return null;
    const { base, perRow } = MULTICITY_ROWS_PLACEHOLDER_HEIGHT[isMobile ? 'mobile' : 'desktop'];
    return (
      <Box
        data-testid="multicity-rows-placeholder"
        aria-hidden
        sx={{ width: '100%', height: `${base + perRow * count}px`, flexShrink: 0 }}
      />
    );
  }
}

export default MultiCityRowsPlaceholder;
